export const makeDisposerController = () => {
  const disposers: Function[] = [];
  return {
    add: (fn: Function) => disposers.push(fn),
    disposer: () => disposers.forEach(d => d()),
  };
};
